<template>
  <v-form ref="form" @submit.prevent="submit" class="containerRisk">
    <QuotationBackButton @back="previousStep" class="mb-6 ml-4" />
    <QuotationRiskForm
      :form="getForm"
      :product="product.id"
      :subProduct="subProduct"
    />
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-0 pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR SOLICITAÇÃO'"
            class="white--text pink"
            width="100%"
            @click="cancelQuotation"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'PRÓXIMO'"
            class="white--text secondary"
            width="100%"
            @click="submit()"
          />
        </v-col>
      </v-row>
    </BaseFooter>
  </v-form>
</template>
<script>
import { mapActions } from "vuex";
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
import { QuotationMixin } from "@/mixins/NewQuotationMixin";
import QuotationBackButton from "../components_agro/QuotationBackButton";
import QuotationRiskForm from "../components_agro/QuotationRiskForm.vue";

export default {
  name: "QuotationStepRisk",
  components: {
    QuotationBackButton,
    QuotationRiskForm
  },
  data: () => ({
    requiredInput,
    dateTermValid,
    maskDate
  }),
  props: {
    product: {
      type: Object
    },
    form: {
      type: Object
    },
    subProduct: {
      type: Object
    }
  },
  mixins: [QuotationMixin],
  created() {
    this.formRisk = this.form;
  },
  computed: {
    nextQuotationStep() {
      return {
        name: "quotation step insured",
        step: 3
      };
    },
    previousQuotationStep() {
      return {
        name: "quotation step product",
        step: 1
      };
    },
    isAgricola() {
      return this.product.id == "agricola";
    },
    isCafezal() {
      return this.product.id == "cafezal";
    },
    getForm() {
      return this.formRisk;
    },
    formElement() {
      return this.$refs.form;
    },
    hasAreaItem() {
      if (this.isAgricola) {
        return this.formRisk.agricola.items.length > 0;
      }
      if (this.isCafezal) {
        return this.formRisk.cafezal.items.length > 0;
      }
      return false;
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);
    this.disableBackButton();
  },
  beforeUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
  },
  methods: {
    getFormForNavigation() {
      return this.formRisk;
    },
    ...mapActions(["hasLoading", "showAlertNotification"]),
    // Lógica a ser executada antes da descarga da página pelo navegador
    handleBeforeUnload(event) {
      event.returnValue = "Deseja realmente sair?";
    },
    disableBackButton() {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", () => {
        history.pushState(null, null, document.URL);
      });
    },
    cancelQuotation() {
      this.$emit("cancel");
    },
    submit() {
      if (
        this.hasAreaItem &&
        this.formRisk.endereco.cep != null &&
        this.formRisk.endereco.cep != ""
      ) {
        this.$emit(
          "updateStep",
          this.payloadQuotation(this.formRisk, this.nextQuotationStep)
        );
      } else {
        if (
          this.formRisk.endereco.cep == null ||
          this.formRisk.endereco.cep == ""
        ) {
          this.showAlertNotification({
            message: "É necessário informar CEP.",
            type: "error"
          });
          return;
        }

        this.showAlertNotification({
          message: "É necessário gravar ao menos uma área.",
          type: "error"
        });
        return;
      }
    },
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadQuotation(this.formRisk, this.previousQuotationStep)
      );
    }
  }
};
</script>
<style lang="sass">
.containerRisk
  max-width: 95% !important
  margin: 0 auto !important
  align-self: center !important
</style>
